import React from 'react';

import WorkEquipmentList from './List';
export default function Index() {
  return (
    <>
      <WorkEquipmentList />
    </>
  );
}
